module.exports = __webpack_public_path__ + "img/cloudPurchase_buy.c32391ea.png";